import React from 'react'

// Componentes
import InputFecha from '../../components/shared/InputFecha.jsx'
import InputHora from '../../components/shared/InputHora.jsx'
import InputDotacionMultiple from '../../components/shared/InputDotacionSimple.jsx'
import InputStock from '../../components/shared/InputStock.jsx'
import Select from '../../components/shared/Select.jsx'
import { SelectLider } from '../../components/shared/SelectLider.jsx'
import { SelectCaptadores } from '../../components/shared/SelectCaptadores.jsx'
import { ButtonSolicitud } from '../../components/shared/ButtonSolicitud.jsx'
import { ModalSuspendidoPago } from './Modales.jsx'

// Styles
import * as css from './TablaSemanal.css'
import classNames from 'classnames/bind'
import Comentarios from './Comentarios.jsx'
import Logistica from './Logistica.jsx'
import CheckBoxNomina from './CheckBoxNomina.jsx'
import ComentariosCliente from './ComentariosCliente.jsx'
import ComentarioIG from './ComentarioIG.jsx'
let cx = classNames.bind(css)

let estadoNominas = [
    '-',                // 0 - nunca ocurre
    'Deshabilitada ',    // 1 - Deshabilitada
    'Pendiente ',        // 2 - Pendiente
    'Recibida ',         // 3 - Recibida
    'Aprobada ',         // 4 - Aprobada
    'Informada ',        // 5 - Informada
    'Inform. Excel '   // 6 - Informada con Excel (plataforma antigua)
]
let labelNominas = [
    'label-default',    // 0 - nunca ocurre
    'label-default',    // 1 - Deshabilitada
    'label-default',    // 2 - Pendiente
    'label-success',    // 3 - Recibida (verde)
    'label-info',       // 4 - Aprobada (celeste)
    'label-primary',    // 5 - Informada (azul)
    'label-primary'     // 6 - Informada con Excel (plataforma antigua)
]
let estadoConteo = [
    'SC',        // 0 Nómina sin calificación
    'PE',        // 1 Nómina en peligro
    'PR',        // 2 Nómina en precaución
    'OP',        // 3 Nómina óptima
    'SD',        // 4 Nómina con mucho conteo
    'SDA'        // 5 Nómina con dotación demasiado alta
]
let labelConteo = [
    'label-default',
    'label-danger',
    'label-warning',
    'label-success',
    'label-info',
    'label-info'
]

class RowInventario extends React.Component {
    focusElemento(elemento) {
        if (elemento === 'dia') {
            this.inputDia.focus()
        } else if (elemento === 'dotacionTotal') {
            // hace focus al primer input de la nomina que este habilitada
            if (this.props.inventario.ndia_habilitada == "1") {
                this.inputDotacionDiaTotal.focus()
            } else if (this.props.inventario.nnoche_habilitada == "1") {
                this.inputDotacionNocheTotal.focus();
            }
        } else if (elemento === 'dotacionOperadores') {
            // hace focus al primer input de la nomina que este habilitada
            if (this.props.inventario.ndia_habilitada == "1") {
                this.inputDotacionDiaOperadores.focus()
            } else if (this.props.inventario.nnoche_habilitada == "1") {
                this.inputDotacionNocheOperadores.focus();
            }
        } else if (elemento === 'stock') {
            this.inputStock.focus()
        } else {
            console.error(`focusElemento(): Elemento "${elemento}" no encontrado`)
        }
    }
    guardarInventario() {
        if (!this.props.puedeModificar)
            return alert("no tiene permitido modificar el inventario")
        let cambiosInventario = {}

        // el DIA es valido, y ha cambiado?
        let estadoInputDia = this.inputDia.getEstado()
        if (estadoInputDia.valid && estadoInputDia.dirty) {
            cambiosInventario.fechaProgramada = estadoInputDia.fecha
        } else if (estadoInputDia.valid === false) {
            return console.log(`fecha ${estadoInputDia.fecha} invalida`)
        }

        // la JORNADA es valida y ha cambiado
        let estadoSelectJornada = this.selectJornada.getEstado()
        if (estadoSelectJornada.dirty)
            cambiosInventario.idJornada = estadoSelectJornada.seleccionUsuario

        // el STOCK es valido y ha cambiado?
        let estadoInputStock = this.inputStock.getEstado()
        if (estadoInputStock.valid && estadoInputStock.dirty)
            cambiosInventario.stockTeorico = estadoInputStock.valor

        // almenos uno de los ementos debe estar "dirty" para guardar los cambios
        if (JSON.stringify(cambiosInventario) !== "{}") {
            this.props.guardarInventario(this.props.inventario.inv_idInventario, cambiosInventario)
        } else {
            console.log('inventario sin cambios, no se actualiza')
        }
    }
    guardarNominaDia(value, extra = {}) {
        this._guardarNomina(this.props.inventario.ndia_idNomina, {
            inputDotacionTotal: this.inputDotacionDiaTotal.getEstado(),
            inputDotacionOperadores: this.inputDotacionDiaOperadores.getEstado(),
            selectLider: {
                ...this.selectLiderDia.getEstado(),
                extra
            },
            selectSupervisor: this.selectSupervisorDia.getEstado(),
            inputHoraPresentacionLider: this.inputHoraPresentacionLiderDia.getEstado(),
            inputHoraPresentacionEquipo: this.inputHoraPresentacionEquipoDia.getEstado()
        })
    }
    guardarNominaNoche(value, extra = {}) {
        this._guardarNomina(this.props.inventario.nnoche_idNomina, {
            inputDotacionTotal: this.inputDotacionNocheTotal.getEstado(),
            inputDotacionOperadores: this.inputDotacionNocheOperadores.getEstado(),
            selectLider: {
                ...this.selectLiderNoche.getEstado(),
                extra
            },
            selectSupervisor: this.selectSupervisorNoche.getEstado(),
            inputHoraPresentacionLider: this.inputHoraPresentacionLiderNoche.getEstado(),
            inputHoraPresentacionEquipo: this.inputHoraPresentacionEquipoNoche.getEstado()
        })
    }
    saveDepartureTime() {
        if (this.inputDepartureTime.getEstado().dirty)
            this.props.saveDepartureTime(this.props.inventario.inv_idInventario, this.inputDepartureTime.getEstado().hora)
    }
    _colorFila(ubicacion = "centro") {
        let inv = this.props.inventario
        const cliente = inv.cliente_idCliente
        const idJornada = inv.inv_idJornada
        const alerta = cliente != 11 && (idJornada == 2)
        const SMUDia = cliente == 11 && (idJornada == 2)
        const recintoCerrado = inv.local_recintoCerrado
        const isMall = inv.local_isMall
        const especial = inv.inv_especial;
        const deshabilitado = inv.inv_suspendido == 1 || inv.nnoche_idLider === 10 || inv.ndia_idLider === 10;
        const isPeriferia = inv.local_comuna_is_periferia;

        let color = "white";
        if (deshabilitado) {
            color = '#b8b8b8'
        } else if (especial)
            color = '#B8F2C2'
        else if (inv.inv_auditoriaSMU)
            color = "#DFA0E8"
        else if (inv.ndia_rectificaSistema === 4 || inv.ndia_rectificaSistema === 5 || inv.nnoche_rectificaSistema === 4 || inv.nnoche_rectificaSistema === 5)
            color = "#7AFF72"
        else if (alerta)
            color = "#f1fc5a"
        else if (SMUDia)
            color = "#fcfaa2"
        else if (recintoCerrado && idJornada == 3)
            color = "#7EDAFF"
        else if (isMall) {
            color = "#F6ABA1"
        } else if (isPeriferia) {
            color = "#CDA986"
        }

        return {
            backgroundColor: color
        };
    }
    _guardarNomina(idNomina, estados) {
        if (!this.props.puedeModificar)
            return alert("no tiene permitido modificar el inventario")

        let cambiosNomina = {}

        // la DOTACION es valida y ha cambiado?
        if (estados.inputDotacionTotal.valid && estados.inputDotacionTotal.dirty)
            cambiosNomina.dotacionTotal = estados.inputDotacionTotal.valor
        if (estados.inputDotacionOperadores.valid && estados.inputDotacionOperadores.dirty)
            cambiosNomina.dotacionOperadores = estados.inputDotacionOperadores.valor

        // el LIDER es valido y ha cambiado? ("deberia" ser valido siempre y cuando no seleccionen la opcion "sin seleccion")
        if (estados.selectLider.dirty) {
            cambiosNomina.idLider = estados.selectLider.seleccionUsuario === null ? '' : estados.selectLider.seleccionUsuario
            if (estados.selectLider.extra && estados.selectLider.extra.suspendidoConPago !== undefined) {
                cambiosNomina.suspendidoConPago = estados.selectLider.extra.suspendidoConPago
            }
        }

        // el SUPERVISOR es valido y ha cambiado? ("deberia" ser valido siempre y cuando no seleccionen la opcion "sin seleccion")
        if (estados.selectSupervisor.dirty)
            cambiosNomina.idSupervisor = estados.selectSupervisor.seleccionUsuario

        // La HORA de llegada del equipo ha cambiado?
        if (estados.inputHoraPresentacionLider.dirty)
            cambiosNomina.horaPresentacionLider = estados.inputHoraPresentacionLider.hora
        if (estados.inputHoraPresentacionEquipo.dirty)
            cambiosNomina.horaPresentacionEquipo = estados.inputHoraPresentacionEquipo.hora


        // almenos uno de los ementos debe estar "dirty" para guardar los cambios
        if (JSON.stringify(cambiosNomina) !== '{}') {
            this.props.guardarNomina(idNomina, cambiosNomina)
        } else {
            console.log('nomina sin cambios, no se actualiza')
        }
    }
    cargarLideresDisponibles = (callback) => {
        callback({ options: [], complete: false })
        this.props.lideresDisponibles(this.props.inventario.nnoche_idNomina, this.props.inventario.ndia_idNomina)
            .then(usuarios => {
                // el callback modifica el state del componente SelectLider
                callback({
                    options: usuarios.map(usuario => ({
                        label: usuario.nombre,
                        value: usuario.idUsuario,
                        enabled: usuario.disponible,
                        blocked: usuario.bloqueado
                    })),
                    complete: true
                })
            })
    }
    cargarAuditoresSMUDisponibles = (callback) => {
        callback({ options: [], complete: false })
        this.props.auditoresSMUDisponibles(this.props.inventario.nnoche_idNomina, this.props.inventario.ndia_idNomina)
            .then(usuarios => {
                // el callback modifica el state del componente SelectLider
                callback({
                    options: usuarios.map(usuario => ({
                        label: usuario.nombre,
                        value: usuario.idUsuario,
                        enabled: usuario.disponible
                    })),
                    complete: true
                })
            })
    }

    formatearTooltip(inv) {
        const stocks = inv.inv_3stocks || [];
        if (!stocks.length) {
            return (
                <span>
                    <span>[Stock al {inv.inv_fechaStock}]</span><br />
                    <span>Promedio inv anteriores: <b>{inv.inv_promStock}</b></span>
                </span>
            );
        }
        return (
            <span>
                <span>[Stock al {inv.inv_fechaStock}]</span><br />
                <span>
                    Promedio inv anteriores: <b>{inv.inv_promStock}</b>
                </span>
                {inv.inv_3stocks && inv.inv_3stocks.length > 0 &&
                    <div style={{ marginTop: '8px', fontSize: '12px', display: 'flex' }}>
                        {/* Columna izquierda: labels */}
                        <div style={{ fontWeight: 'bold', marginRight: '10px' }}>
                            <div>Conteo</div>
                            <div>Fecha</div>
                            <div>Operadores</div>
                            <div>Duración</div>
                            <div>Nota</div>
                        </div>
                        {/* Columnas dinámicas */}
                        {stocks.map((s, i) => {
                            if (!s.conteo) {
                                return null;
                            }
                            return (
                                <div key={i} style={{ marginRight: '15px' }}>
                                    <div>
                                        {s.conteo
                                            ? Number(s.conteo).toLocaleString("es-CL")
                                            : "-"}
                                    </div>
                                    <div>{s.fecha || "-"}</div>
                                    <div>{s.operadores || 0}</div>
                                    <div>{s.duracion || "-"}</div>
                                    <div>{s.nota_conteo || "-"}</div>
                                </div>
                            )
                        })}
                    </div>}
            </span>
        );
    }

    estadoPermiso(permisosMall) {
        const algunoIncompleto = permisosMall.find(permiso => permiso.fecha_completado == null);
        const estado = algunoIncompleto ? algunoIncompleto.estado : permisosMall[0].estado;
        if (estado === 'Aprobado' || estado === 'Aceptado') {
            return css.permisoMall_aceptado;
        }

        if (estado === 'Rechazado') {
            return css.permisoMall_rechazado;
        }

        if (estado === 'Completar' || estado === 'Solicitado') {
            return css.permisoMall_completar;
        }

        return css.permisoMall_pendiente;
    }

    selectColorPermiso(permisosMall) {
        const algunoIncompleto = permisosMall.find(permiso => permiso.fecha_completado == null);
        if (algunoIncompleto) {
            return {
                borderRadius: '9999px',
                borderWidth: '1px',
                paddingLeft: '0.5rem',
                paddingRight: '0.5rem',
                border: '#222222',
                backgroundColor: algunoIncompleto.color,
                color: '#EEE'
            };
        }
        return {
            borderRadius: '9999px',
            borderWidth: '1px',
            paddingLeft: '0.5rem',
            paddingRight: '0.5rem',
            border: '#222222',
            backgroundColor: permisosMall[0].color,
            color: '#EEE'
        };
    }

    render() {
        let inv = this.props.inventario
        const idJornada = inv.inv_idJornada
        const cliente = inv.cliente_idCliente
        const inventarioDia = idJornada == 2 || idJornada == 4
        const inventarioNoche = idJornada == 3 || idJornada == 4
        // puede eeditar si la nomina esta habilitada, y no esta en estado "informada"(5) o "informada excel"(6)
        let informadaDia = inv.ndia_idEstadoNomina == 5 || inv.ndia_idEstadoNomina == 6
        let informadaNoche = inv.nnoche_idEstadoNomina == 5 || inv.nnoche_idEstadoNomina == 6
        // puede editar la NOMINA si tiene los permisos, esta habilitada, y esta no ha sido informada
        let puedeEditarNominaDia = this.props.puedeModificarPro && inv.ndia_habilitada == "1" && !informadaDia
        let puedeEditarNominaNoche = this.props.puedeModificarPro && inv.nnoche_habilitada == "1" && !informadaNoche
        // puede editar dotacion NOMINA
        let puedeEditarNominaDiaDot = this.props.puedeModificarDotaciones && inv.ndia_habilitada == "1" && !informadaDia
        let puedeEditarNominaNocheDot = this.props.puedeModificarDotaciones && inv.nnoche_habilitada == "1" && !informadaNoche
        // el captador se puede editar siempre que se tengan los permisos y que la nomina este habilitada
        // let puedeEditarCaptadorDia = this.props.puedeModificar && inv.ndia_habilitada=="1"
        // let puedeEditarCaptadorNoche = this.props.puedeModificar && inv.nnoche_habilitada=="1"

        // el inventario se puede editar solo si tiene los permisos, y no hay una nomina informada
        let puedeEditar_fecha_turno_stock = this.props.puedeModificar && !informadaDia && !informadaNoche
        let puedeModificarCaptador = this.props.puedeModificarCaptador && !informadaDia && !informadaNoche
        let puedeModificar_stock = this.props.puedeEditarStock && !informadaDia && !informadaNoche
        let _hrApertura = inv.local_horaApertura.split(':')
        let txtHrApertura = `Apertura a las ${_hrApertura[0]}:${_hrApertura[1]}hrs`
        let _hrCierre = inv.local_horaCierre.split(':')
        let txtHrCierre = `Cierre a las ${_hrCierre[0]}:${_hrCierre[1]}hrs`
        let notaPromedio = inv.acta_nota1 != 'sin datos' ? ((parseFloat(inv.acta_nota1) + parseFloat(inv.acta_nota2) + parseFloat(inv.acta_nota3)) / 3).toFixed(1) : null
        let notas = notaPromedio ? `${inv.acta_nota1} / ${inv.acta_nota2} / ${inv.acta_nota3} / ${notaPromedio}` : 'sin datos'

        let isAuditoriaSMU = inv.inv_auditoriaSMU ? true : false;
        let index = this.props.index;

        let titularesDia = inv.ndia_totalTitulares.filter((row) => {
            return !row.lider;
        });
        let titularesNoche = inv.nnoche_totalTitulares.filter((row) => {
            return !row.lider;
        });
        let status_asistencia_global_dia =
            inventarioDia ? titularesDia.length != 0 && titularesDia.filter((row) => {
                return row.estado_asistencia >= 3;
            }).length == titularesDia.length : false;
        let status_asistencia_global_noche =
            inventarioNoche ? titularesNoche.length != 0 &&
                titularesNoche.filter((row) => {
                    return row.estado_asistencia >= 3;
                }).length == titularesNoche.length
                : false;
        const deshabilitado = inv.nnoche_idLider === 10 || inv.ndia_idLider === 10 || inv.inv_suspendido === 1;
        const isPermisoMall = (inv.local_isMall && inv.local_tipoMall.is_permiso_mall) || inv.permisos_mall.length != 0;
        const tieneAsignadoPermiso = inv.permisos_mall.length != 0;
        return (
            <tr className={this.props.mostrarSeparador ? css.trSeparador : ''}>
                {/* Correlativo */}
                <td className={css.tdCorrelativo}>
                    <p title={inv.inv_idInventario}>{this.props.index + 1}</p>
                </td>
                {/* Logistica */}
                <td className={css.tdLogistica} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    <Logistica
                        idLocal={inv.local_idLocal}
                        tiene={inv.local_logistica}
                    />
                </td>
                <td className={css.tdInv} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    <ComentarioIG idInventario={inv.inv_idInventario} placement={'right'} />
                </td>
                {/* Fecha */}
                <td className={css.tdFecha} style={{ ...this._colorFila('left'), opacity: deshabilitado ? '50%' : '100%' }}>
                    <InputFecha
                        ref={ref => this.inputDia = ref}
                        diaSemana={inv.inv_fechaProgramadaDOW}
                        fechaConProblemas={inv.local_topeFechaConAuditoria}
                        fecha={inv.inv_fechaProgramada}
                        onGuardar={this.guardarInventario.bind(this)}
                        puedeModificar={puedeEditar_fecha_turno_stock}
                        focusRowAnterior={() => this.props.focusRow(this.props.index - 1, 'dia')}
                        focusRowSiguiente={() => this.props.focusRow(this.props.index + 1, 'dia')} />
                </td>
                {/* Cliente*/}
                <td className={css.tdCliente} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    <p className={css.mytooltip}>
                        <div
                            className={isPermisoMall ? (tieneAsignadoPermiso ? this.estadoPermiso(inv.permisos_mall) : css.isPermisoMall_pendiente) : ''}
                        >{inv.cliente_nombreCorto}</div>
                        <span className={css.tooltipTableNominaAnterior}>
                            <TableNominaAnterior
                                fecha={inv.nomina_anterior_fecha}
                                turno={inv.nomina_anterior_turno}
                                nomina={inv.nomina_anterior_stats}
                                stats={inv.stats} />
                        </span>
                    </p>
                </td>
                {/* CECO */}
                <td className={css.tdCeco} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    <p className={css.tooltip}>
                        {inv.local_ceco}
                        <span className={css.tooltiptext}>
                            Lider: {inv.ult_lider}<br />
                            Prod.Sugerida: {inv.local_produccionSugerida}<br />
                            Fecha último inv: {inv.acta_fecha_toma}<br />
                            Llegada último inv: {inv.acta_hora_llegada}<br />
                            Inicio Conteo último inv: {inv.acta_inicio_conteo}<br />
                            Fin Conteo último inv: {inv.acta_fin_conteo}<br />
                            Tot. hrs. conteo : {inv.acta_revision_grilla}<br />
                            Duración revisión: {inv.acta_duracion_revision}<br />
                            Fin Proceso último inv: {inv.acta_fin_proceso}<br />
                            Dot. último inv: {inv.acta_dot}<br />
                            Tot. sala último inv: {inv.acta_total_sala}<br />
                            Tot. bod. último inv: {inv.acta_total_bodega}<br />
                            Tot. unds contadas: {inv.acta_unidades}<br />
                            Tot. unds teórico: {inv.acta_unidades_teorico}<br />
                            Notas (C/P/S/X): {notas}<br />
                            Error SEI: {inv.acta_error_sei}<br />
                            Estandar SEI: {inv.acta_estandar}<br />
                        </span>
                    </p>
                </td>
                {/* Region */}
                <td className={css.tdRegion} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    <p>{inv.local_region}</p>
                </td>
                {/* Comuna */}
                <td className={css.tdComuna} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    <Comentarios
                        comuna={inv.local_comuna}
                        idInventario={inv.inv_idInventario}
                        comentarios={inv.inv_comentarios}
                        updateComentarios={this.props.updateComentarios}
                    />
                </td>
                {/* Turno */}
                <td className={css.tdTurno} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    {<Select
                        ref={ref => this.selectJornada = ref}
                        onSelect={this.guardarInventario.bind(this)}
                        opciones={isAuditoriaSMU ?
                            [
                                { valor: '1', texto: 'ND' },
                                { valor: '2', texto: 'D' }]
                            : [
                                { valor: '1', texto: 'ND' },
                                { valor: '2', texto: 'D' },
                                { valor: '3', texto: 'N' },
                                { valor: '4', texto: 'DyN' }
                            ]}
                        seleccionada={'' + inv.inv_idJornada}
                        puedeModificar={puedeEditar_fecha_turno_stock && !deshabilitado}

                    />}
                </td>
                {/* Tienda */}
                <td className={css.tdTienda} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    <p className={css.textoConTooltip}>
                        <span>Apertura: {inv.local_horaApertura}, Cierre:{inv.local_horaCierre}</span>
                    </p>
                    <ComentariosCliente
                        local={inv.local_nombre}
                        idLocal={inv.local_idLocal}
                        comentarios={inv.local_comentarios}
                        updateComentarios={this.props.updateComentariosClientes}
                        puedeValidarComentarios={this.props.puedeValidarComentarios}
                    />
                </td>
                {/* Stock */}
                <td className={css.tdStock} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    <InputStock
                        ref={ref => this.inputStock = ref}
                        asignada={'' + inv.inv_stockTeorico}  // pide en string
                        tooltipText={this.formatearTooltip(inv)}
                        onGuardar={this.guardarInventario.bind(this)}
                        stockAntiguo={inv.inv_fechaStockAntigua}
                        focusRowAnterior={() => this.props.focusRow(this.props.index - 1, 'stock')}
                        focusRowSiguiente={() => this.props.focusRow(this.props.index + 1, 'stock')}
                        puedeModificar={puedeModificar_stock && !deshabilitado}
                    />
                </td>
                {/* Dotación Total */}
                <td className={css.tdDotacionTotal} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    {/* Dotaion de Dia */}
                    <InputDotacionMultiple
                        style={{ display: inventarioDia ? 'block' : 'none' }}
                        className="pull-left"
                        ref={ref => this.inputDotacionDiaTotal = ref}
                        asignada={'' + inv.ndia_dotTotal} // pide un string...
                        onGuardar={this.guardarNominaDia.bind(this)}
                        focusRowAnterior={() => this.props.focusRow(this.props.index - 1, 'dotacionTotal')}
                        focusRowSiguiente={() => this.props.focusRow(this.props.index + 1, 'dotacionTotal')}
                        puedeModificar={puedeEditarNominaDiaDot && inv.ndia_estadoDotacion == 1 && !deshabilitado}
                        idInv={inv.inv_idInventario}
                    />
                    <InputDotacionMultiple
                        style={{ display: inventarioDia ? 'block' : 'none' }}
                        className="pull-right"
                        ref={ref => this.inputDotacionDiaOperadores = ref}
                        asignada={'' + inv.ndia_dotOperadores} // pide un string...
                        onGuardar={this.guardarNominaDia.bind(this)}
                        focusRowAnterior={() => this.props.focusRow(this.props.index - 1, 'dotacionOperadores')}
                        focusRowSiguiente={() => this.props.focusRow(this.props.index + 1, 'dotacionOperadores')}
                        puedeModificar={puedeEditarNominaDiaDot && inv.ndia_estadoDotacion == 1 && !deshabilitado}
                        tooltipText={inv.ndia_dotacionInformada}
                        idInv={inv.inv_idInventario}
                    />
                    {/* Dotacion de Noche*/}
                    <InputDotacionMultiple
                        style={{ display: inventarioNoche ? 'block' : 'none' }}
                        className="pull-left"
                        ref={ref => this.inputDotacionNocheTotal = ref}
                        asignada={'' + inv.nnoche_dotTotal}  // pide un string...
                        onGuardar={this.guardarNominaNoche.bind(this)}
                        focusRowAnterior={() => this.props.focusRow(this.props.index - 1, 'dotacionTotal')}
                        focusRowSiguiente={() => this.props.focusRow(this.props.index + 1, 'dotacionTotal')}
                        puedeModificar={puedeEditarNominaNocheDot && inv.nnoche_estadoDotacion == 1 && !deshabilitado}
                        idInv={inv.inv_idInventario}
                    />
                    <InputDotacionMultiple
                        style={{ display: inventarioNoche ? 'block' : 'none' }}
                        className="pull-right"
                        ref={ref => this.inputDotacionNocheOperadores = ref}
                        asignada={'' + inv.nnoche_dotOperadores}  // pide un string...
                        onGuardar={this.guardarNominaNoche.bind(this)}
                        focusRowAnterior={() => this.props.focusRow(this.props.index - 1, 'dotacionOperadores')}
                        focusRowSiguiente={() => this.props.focusRow(this.props.index + 1, 'dotacionOperadores')}
                        puedeModificar={puedeEditarNominaNocheDot && inv.nnoche_estadoDotacion == 1 && !deshabilitado}
                        tooltipText={inv.nnoche_dotacionInformada}
                        idInv={inv.inv_idInventario}
                    />
                    <ButtonSolicitud
                        onGuardar={this.props.estadoSolicitud.bind(this)}
                        idNomina={inv.nnoche_idNomina}
                        visible={inventarioNoche && inv.nnoche_estadoDotacion != 1}
                        idEstadoDotacion={inv.nnoche_estadoDotacion}
                    />
                    <ButtonSolicitud
                        onGuardar={this.props.estadoSolicitud.bind(this)}
                        idNomina={inv.ndia_idNomina}
                        visible={inventarioDia && inv.ndia_estadoDotacion != 1}
                        idEstadoDotacion={inv.ndia_estadoDotacion}
                    />
                </td>
                {/* Lider */}
                <td className={css.tdUsuario} style={{ ...this._colorFila('centro') }}>
                    <SelectLider visible={inventarioDia}
                        editable={puedeEditarNominaDia}
                        selectedValue={inv.ndia_idLider || ''}
                        selectedLabel={inv.ndia_lider}
                        onOpenList={isAuditoriaSMU ? this.cargarAuditoresSMUDisponibles : this.cargarLideresDisponibles}
                        ref={ref => this.selectLiderDia = ref}
                        onChange={this.guardarNominaDia.bind(this)}
                    />
                    <SelectLider visible={inventarioNoche}
                        editable={puedeEditarNominaNoche}
                        selectedValue={inv.nnoche_idLider || ''}
                        selectedLabel={inv.nnoche_lider}
                        onOpenList={isAuditoriaSMU ? this.cargarAuditoresSMUDisponibles : this.cargarLideresDisponibles}
                        ref={ref => this.selectLiderNoche = ref}
                        onChange={this.guardarNominaNoche.bind(this)}
                    />
                </td>
                {/* Hora Presentación Lider */}
                <td className={css.tdHora} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    <InputHora
                        style={{ display: inventarioDia ? 'block' : 'none' }}
                        ref={ref => this.inputHoraPresentacionLiderDia = ref}
                        asignada={inv.ndia_hrLider}
                        tooltipText={txtHrApertura}
                        onGuardar={this.guardarNominaDia.bind(this)}
                        focusRowAnterior={() => { }}
                        focusRowSiguiente={() => { }}
                        puedeModificar={puedeEditarNominaDia && !deshabilitado}
                    />
                    <InputHora
                        style={{ display: inventarioNoche ? 'block' : 'none' }}
                        ref={ref => this.inputHoraPresentacionLiderNoche = ref}
                        asignada={inv.nnoche_hrLider}
                        tooltipText={txtHrCierre}
                        onGuardar={this.guardarNominaNoche.bind(this)}
                        focusRowAnterior={() => { }}
                        focusRowSiguiente={() => { }}
                        puedeModificar={puedeEditarNominaNoche && !deshabilitado}
                    />
                </td>
                {/* Hora Presentación Equipo*/}
                <td className={css.tdHora} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    <InputHora
                        style={{ display: inventarioDia ? 'block' : 'none' }}
                        ref={ref => this.inputHoraPresentacionEquipoDia = ref}
                        asignada={inv.ndia_hrEquipo}
                        tooltipText={txtHrApertura}
                        onGuardar={this.guardarNominaDia.bind(this)}
                        focusRowAnterior={() => { }}
                        focusRowSiguiente={() => { }}
                        puedeModificar={puedeEditarNominaDia && !deshabilitado}
                    />
                    <InputHora
                        style={{ display: inventarioNoche ? 'block' : 'none' }}
                        ref={ref => this.inputHoraPresentacionEquipoNoche = ref}
                        asignada={inv.nnoche_hrEquipo}
                        tooltipText={txtHrCierre}
                        onGuardar={this.guardarNominaNoche.bind(this)}
                        focusRowAnterior={() => { }}
                        focusRowSiguiente={() => { }}
                        puedeModificar={puedeEditarNominaNoche && !deshabilitado}
                    />
                </td>
                {/* Supervisor */}
                <td className={css.tdUsuario} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    <Select style={{ display: inventarioDia ? 'block' : 'none' }}
                        ref={ref => this.selectSupervisorDia = ref}
                        seleccionada={'' + inv.ndia_idSupervisor || ''}
                        onSelect={this.guardarNominaDia.bind(this)}
                        opciones={this.props.opcionesSupervisores}
                        opcionNula={true}
                        opcionNulaSeleccionable={true}
                        puedeModificar={puedeEditarNominaDia && !deshabilitado}
                    />
                    <Select style={{ display: inventarioNoche ? 'block' : 'none' }}
                        ref={ref => this.selectSupervisorNoche = ref}
                        seleccionada={'' + inv.nnoche_idSupervisor || ''}
                        onSelect={this.guardarNominaNoche.bind(this)}
                        opciones={this.props.opcionesSupervisores}
                        opcionNula={true}
                        opcionNulaSeleccionable={true}
                        puedeModificar={puedeEditarNominaNoche && !deshabilitado}
                    />
                </td>
                {/* Captadores */}
                <td className={css.tdUsuario} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    <SelectCaptadores
                        puedeEditar={puedeModificarCaptador && !deshabilitado}
                        visible={inventarioDia}
                        captadoresDisponibles={this.props.captadoresDisponibles}
                        captadores={inv.ndia_captadores}
                        agregarCaptador={this.props.agregarCaptador.bind(this, inv.ndia_idNomina)}
                        quitarCaptador={this.props.quitarCaptador.bind(this, inv.ndia_idNomina)}
                        agregarRegionesCaptador={this.props.agregarRegionesCaptador.bind(this, inv.ndia_idNomina)}
                        cerrarRegion={this.props.cerrarRegion}
                        cambiarAsignados={this.props.cambiarAsignados.bind(this, inv.ndia_idNomina)}
                        idInventario={inv.inv_idInventario}
                        regiones={inv.regiones}
                    />
                    <SelectCaptadores
                        puedeEditar={puedeModificarCaptador && !deshabilitado}
                        visible={inventarioNoche}
                        captadoresDisponibles={this.props.captadoresDisponibles}
                        captadores={inv.nnoche_captadores}
                        agregarCaptador={this.props.agregarCaptador.bind(this, inv.nnoche_idNomina)}
                        quitarCaptador={this.props.quitarCaptador.bind(this, inv.nnoche_idNomina)}
                        agregarRegionesCaptador={this.props.agregarRegionesCaptador.bind(this, inv.nnoche_idNomina)}
                        cerrarRegion={this.props.cerrarRegion}
                        cambiarAsignados={this.props.cambiarAsignados.bind(this, inv.nnoche_idNomina)}
                        idInventario={inv.inv_idInventario}
                        regiones={inv.regiones}
                    />
                </td>
                {/* Departure time Store */}
                <td className={css.tdHora} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    <InputHora
                        style={{ display: 'block' }}
                        ref={ref => this.inputDepartureTime = ref}
                        asignada={inv.store_departureTime}
                        tooltipText={txtHrApertura}
                        onGuardar={this.saveDepartureTime.bind(this)}
                        focusRowAnterior={() => { }}
                        focusRowSiguiente={() => { }}
                        puedeModificar={true && !deshabilitado}
                    />
                </td>
                {/* Dirección */}
                <td className={css.tdDireccion} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    {inv.local_gmap_latitud && inv.local_gmap_longitud
                        ? <a href={`https://www.google.com/maps/search/?api=1&query=${inv.local_gmap_latitud}, ${inv.local_gmap_longitud}`}
                            target="_blank">
                            {inv.local_direccion}<span className='glyphicon glyphicon-map-marker'></span>
                        </a>

                        : inv.local_direccion}


                </td>
                {/* Checkbox Nómina*/}
                <td className={css.tdCheckboxNomina} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    {/* Nomina de Día */}
                    {inventarioDia
                        ? <CheckBoxNomina
                            //idInventario={inv.inv_idInventario}
                            initialChecked={this.props.checkboxesNomina.nominaDia.status}
                            setValueCheckbox={this.props.setValueCheckbox}
                            css={cx('center-block')}
                            idNomina={inv.ndia_idNomina}
                            disabled={deshabilitado}
                        />
                        : ''}
                    {/* Nomina de Noche */}
                    {inventarioNoche
                        ? <CheckBoxNomina
                            //idInventario={inv.inv_idInventario}
                            initialChecked={this.props.checkboxesNomina.nominaNoche.status}
                            setValueCheckbox={this.props.setValueCheckbox}
                            css={cx('center-block')}
                            idNomina={inv.nnoche_idNomina}
                            disabled={deshabilitado}
                        />
                        : ''}
                </td>
                {/* Nómina*/}
                <td className={css.tdNomina} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    {/* Nomina de Día */}
                    <p className={css.mytooltip}>
                        <a href={deshabilitado ? '#' : `/nomina/${inv.ndia_idNomina}`}
                            className={cx(
                                'label',
                                !inv.ndia_rectificada && inv.ndia_idEstadoNomina < 5 ? css.nominaNuncaInformada : "",
                                // color depende del valor de la fechaSubida
                                labelNominas[inv.ndia_idEstadoNomina],
                                inventarioDia ? 'center-block' : 'hide'
                            )}
                            target={deshabilitado ? '' : "_blank"} style={{ backgroundColor: (inv.ndia_totalTitulares_baja > 0 ? 'red' : (inv.ndia_conBaja ? 'black' : '')) }}
                        >
                            {estadoNominas[inv.ndia_idEstadoNomina]}
                            {inv.ndia_totalEscondidos.length > 0 ? <span style={{ color: 'white' }} className="glyphicon glyphicon-user"></span> : null}
                            {(inv.ndia_bloqueoDotacion == true || inv.ndia_totalTitulares_baja > 0) ? <span style={{ color: 'red' }} className="glyphicon glyphicon-lock"></span> : null}
                            {inv.ndia_totalMasTiempo.length > 0 ? <span style={{ color: 'white' }} className="glyphicon glyphicon-time"></span> : null}
                        </a>
                        {!deshabilitado && <span className={css.tooltipTable}>
                            <TableInfoNomina nomina={inv.ndia_totalTitulares} captadores={inv.ndia_captadores} stock={inv.inv_stockTeorico}
                                localN={inv.cliente_nombreCorto} localC={inv.local_ceco} fecha={inv.inv_fechaProgramada} bajas={inv.ndia_totalDadosBaja} escondidos={inv.ndia_totalEscondidos}
                                mensaje={inv.ndia_mensajeCorto}
                                isPermisoMall={isPermisoMall && inv.permisos_mall.length != 0}
                                permisosMall={inv.permisos_mall}
                            />
                        </span>}
                    </p>
                    {/* Nomina de Noche */}
                    <div className={css.mytooltip}>
                        <a href={deshabilitado ? '#' : `/nomina/${inv.nnoche_idNomina}`}
                            className={cx(
                                'label',
                                !inv.nnoche_rectificada && inv.nnoche_idEstadoNomina < 5 ? css.nominaNuncaInformada : (""),
                                // color depende del valor de la fechaSubida
                                labelNominas[inv.nnoche_idEstadoNomina],
                                inventarioNoche ? 'center-block' : 'hide'
                            )}
                            target={deshabilitado ? '' : "_blank"} style={{ backgroundColor: (inv.nnoche_totalTitulares_baja > 0 ? 'red' : (inv.nnoche_conBaja ? 'black' : '')) }}
                        >
                            {estadoNominas[inv.nnoche_idEstadoNomina]}
                            {inv.nnoche_totalEscondidos.length > 0 ? <span style={{ color: 'white' }} className="glyphicon glyphicon-user"></span> : null}
                            {inv.nnoche_bloqueoDotacion == true ? <span style={{ color: 'red' }} className="glyphicon glyphicon-lock"></span> : null}
                            {inv.nnoche_totalMasTiempo.length > 0 ? <span style={{ color: 'white' }} className="glyphicon glyphicon-time"></span> : null}
                        </a>
                        {!deshabilitado && <span className={css.tooltipTable}>
                            <TableInfoNomina nomina={inv.nnoche_totalTitulares} captadores={inv.nnoche_captadores} stock={inv.inv_stockTeorico}
                                localN={inv.cliente_nombreCorto} localC={inv.local_ceco} fecha={inv.inv_fechaProgramada} bajas={inv.nnoche_totalDadosBaja} escondidos={inv.nnoche_totalEscondidos}
                                mensaje={inv.nnoche_mensajeCorto}
                                isPermisoMall={isPermisoMall && inv.permisos_mall.length != 0}
                                permisosMall={inv.permisos_mall}
                            />
                        </span>}
                    </div>
                </td>
                {/* Nómina calificación*/}
                <td className={css.tdNomina} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    {/* Nomina de Día */}
                    <p className={css.textoConTooltip}>
                        <a
                            className={cx(
                                'label',
                                // color depende de la calificación nómina
                                labelConteo[inv.ndia_calificacionNomina],
                                inventarioDia ? 'center-block' : 'hide'
                            )}
                            style={
                                inv.ndia_calificacionNomina === 1 && inv.ndia_porcentaje > 75
                                    ? { backgroundColor: '#fc7905', borderColor: '#fc7905' } // naranjo real
                                    : {}
                            }
                        >
                            {/* {estadoConteo[inv.ndia_calificacionNomina]} */}
                            {inv.ndia_porcentaje ? (inv.ndia_porcentaje > 400 ? "..." : inv.ndia_porcentaje) : 0}%
                        </a>
                        {!deshabilitado && <span className={css.tooltiptext}>
                            -{inv.ndia_mensaje}.<br />
                            -Stock Promedio Local: {inv.ndia_stockSugerido}<br />
                            -Stock Informado: {Number(inv.inv_stockTeorico).toLocaleString('en-US')}<br />
                            -Conteo Sugerido: {inv.ndia_conteoSugerido}<br />
                            -Operadores: {inv.ndia_totalTitulares.length + ' de ' + inv.ndia_dotOperadores}<br />
                            -Operadores nuevos: {inv.ndia_cantidadNuevos}
                        </span>}
                    </p>

                    {/* Nomina de Noche */}
                    <p className={css.textoConTooltip}>
                        <a
                            className={cx(
                                'label',
                                // color depende de la calificación de nomina
                                labelConteo[inv.nnoche_calificacionNomina],
                                inventarioNoche ? 'center-block' : 'hide'
                            )}
                            style={
                                inv.nnoche_calificacionNomina === 1 && inv.nnoche_porcentaje > 75
                                    ? { backgroundColor: '#fc7905', borderColor: '#fc7905' } // naranjo real
                                    : {}
                            }
                        >
                            {/* {estadoConteo[inv.nnoche_calificacionNomina]} */}
                            {inv.nnoche_porcentaje ? (inv.nnoche_porcentaje > 400 ? "..." : inv.nnoche_porcentaje) : 0}%
                        </a>
                        {!deshabilitado && <span>
                            -{inv.nnoche_mensaje}.<br />
                            -Stock Promedio Local: {inv.nnoche_stockSugerido}<br />
                            -Stock Informado: {Number(inv.inv_stockTeorico).toLocaleString('en-US')}<br />
                            -Conteo Sugerido: {inv.nnoche_conteoSugerido}<br />
                            -Operadores: {inv.nnoche_totalTitulares.length + ' de ' + inv.nnoche_dotOperadores}<br />
                            -Operadores nuevos: {inv.nnoche_cantidadNuevos}
                        </span>}
                    </p>
                </td>
                {/* REPORTES */}
                <td className={css.tdReportes} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    {inventarioDia && <div style={{ marginLeft: 'auto', marginRight: 'auto' }} className={status_asistencia_global_dia ? css.asistencia_5 : css.asistencia_0}> </div>}
                    {inventarioNoche && <div style={{ marginLeft: 'auto', marginRight: 'auto' }} className={status_asistencia_global_noche ? css.asistencia_5 : css.asistencia_0}></div>}
                    {/*<p className={css.textoConTooltip}>
                        {inv.inv_reporte == 0 ? <input className={css.radioButton0} type="radio" defaultChecked/> : 
                        (inv.inv_reporte == 1 ? <input className={css.radioButton1} type="radio" defaultChecked/> : 
                        (inv.inv_reporte == 2 ? <input className={css.radioButton2} type="radio" defaultChecked/> : 
                        (<input className={css.radioButton3} type="radio" defaultChecked/> )))}
                        <span>
                            {inv.inv_reporte == 0 ? "Reporte NO Iniciado" : (inv.inv_reporte == 1 ? "Reporte Iniciado" :
                            (inv.inv_reporte == 2 ? "Reporte Avance" : "Reporte Finalizado"))}
                        </span>
                    </p>*/}
                </td>
                {/* Patentes */}
                <td className={css.tdPatentes} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    {inv.inv_patentes}
                </td>
                {/* PDAs */}
                <td className={css.tdPda} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    {inv.inv_pda}
                </td>
                {/* Unidades */}
                <td className={css.tdUnidadesReales} style={{ ...this._colorFila('centro'), opacity: deshabilitado ? '50%' : '100%' }}>
                    {inv.inv_unidadesReales}
                </td>
                {/* <td className={css.tdUnidadesTeoricas} style={this._colorFila('centro')}>
                    {inv.inv_unidadesTeorico}
                </td> */}
                {/* Acta */}
                <td className={css.tdArchivoFinal} style={{ ...this._colorFila('right'), opacity: deshabilitado ? '50%' : '100%' }}>
                    {/* Mostrar el boton de acta solo para el cliente FCV */}
                    <a className={cx('label', 'center-block', {
                        'label-default': inv.inv_estadoArchivoFinal == 'pendiente',
                        'label-info': inv.inv_estadoArchivoFinal == 'por publicar',
                        'label-primary': inv.inv_estadoArchivoFinal == 'publicado'
                    })} href={deshabilitado ? '#' : `/inventario/${inv.inv_idInventario}/archivo-final`} target="_blank">
                        {inv.inv_estadoArchivoFinal}
                    </a>
                </td>
            </tr>
        )
    }
}

const TableInfoNomina = ({ nomina, captadores, stock, localN, localC, fecha, bajas, escondidos, mensaje, isPermisoMall = false, permisosMall = [] }) => {

    const usuariosConPermisoMap = new Map;
    for (const permisoMall of permisosMall) {
        for (const user of permisoMall.users_registrados) {
            usuariosConPermisoMap.set(user.user_id, user);
        }
    }

    const totales = {
        //exp: 0,
        //error: 0,
        sug: 0,
        real: 0
    }

    const onColorAsistencia = (asistencia) => {
        if (asistencia < 2) {
            return css.asistencia_0;
        }
        if (asistencia >= 2) {
            return css.asistencia_2;
        }
    }

    const onColorAsistencia2 = (asistencia) => {
        if (asistencia <= 2) {
            return css.asistencia_0;
        }
        if (asistencia >= 3) {
            return css.asistencia_3;
        }

        // if (asistencia == 4) {
        //     return css.asistencia_4;
        // }
        // if (asistencia == 5) {
        //     return css.asistencia_5;
        // }
    }

    const onColorAsistencia3 = (asistencia) => {
        if (asistencia < 4) {
            return css.asistencia_camino;
        }
        if (asistencia == 4) {
            return css.asistencia_4;
        }
        if (asistencia == 5) {
            return css.asistencia_5;
        }
    }

    const nominaFiltrada = nomina.filter(operadorNomina =>
        !bajas.some(operadorBaja => operadorBaja.nombreCorto === operadorNomina.nombreCorto)
    );

    const rows = nominaFiltrada.map((operador, index) => {

        const captador = captadores.find((captador) => captador.idUsuario == operador.captador);
        //totales.exp += operador.experienciaComoOperador; 
        //totales.error += operador.error,
        const esLider = operador.lider;
        if (!esLider) {
            totales.sug += operador.unidadesContadas;
            totales.real += operador.unidadesContadasReal;
        }
        return (
            <tr key={index} style={{ color: esLider ? "#10de39" : "white" }}>
                <td>{esLider ? "Líder" : index}</td>
                {isPermisoMall
                    ? <td>{usuariosConPermisoMap.has(operador.id) ? <div className={'glyphicon glyphicon-ok ' + css.userConPermisoMall}></div> : <div className={'glyphicon glyphicon-remove ' + css.userSinPermisoMall} color='red'></div>}</td>
                    : null}
                <td
                    style={{
                        color: operador.bloqueado == 1 ? "red" : (operador.bloqueadoCliente ? "orange" : (esLider ? "#10de39" : "white"))
                    }}
                >
                    {operador.nombreCorto}</td>
                <td>{captador ? captador.nombre : '-'}</td>
                <td>{operador.comuna}</td>
                <td>{operador.experienciaComoOperador}</td>
                <td
                    style={{
                        color: operador.error >= 1 ? "red" : (esLider ? "#10de39" : "white")
                    }}
                >
                    {operador.error}</td>
                <td style={{
                    textAlign: "right"
                }}>{new Intl.NumberFormat('de-DE').format(operador.unidadesContadas)}</td>
                <td style={{
                    textAlign: "right"
                }}>{new Intl.NumberFormat('de-DE').format(operador.unidadesContadasReal)}</td>
                {operador.estado_asistencia == "-1"
                    ? <td colSpan={2}><div className='text-center' style={{ backgroundColor: 'red', color: 'white', borderRadius: '20%' }}>BAJA</div></td>
                    : null}
                {esLider || operador.estado_asistencia == "-1"
                    ? null
                    : <td><div className={onColorAsistencia(operador.estado_asistencia)}></div></td>}
                {esLider || operador.estado_asistencia == "-1"
                    ? null
                    : <td><div className={onColorAsistencia2(operador.estado_asistencia)}></div></td>}
                {esLider || operador.estado_asistencia == "-1"
                    ? null
                    : <td><div className={onColorAsistencia3(operador.estado_asistencia)}></div></td>}
            </tr>
        );
    });

    const rowsEscondidos = escondidos.map((operador, index) => {

        const captador = captadores.find((captador) => captador.idUsuario == operador.captador);
        //totales.exp += operador.experienciaComoOperador; 
        //totales.error += operador.error,
        totales.sug += operador.unidadesContadas;
        totales.real += operador.unidadesContadasReal;
        return (
            <tr key={index}>
                <td>{index + 1}</td>
                {isPermisoMall ? <td>{usuariosConPermisoMap.has(operador.id) ? <div className={'glyphicon glyphicon-ok ' + css.userConPermisoMall}></div> : <div className={'glyphicon glyphicon-remove ' + css.userSinPermisoMall} color='red'></div>}</td> : null}
                <td
                    style={{
                        color: operador.bloqueado == 1 ? "red" : (operador.bloqueadoCliente ? "orange" : "#10c6de")
                    }}
                >
                    {operador.nombreCorto}</td>
                <td>{captador ? captador.nombre : '-'}</td>
                <td>{operador.comuna}</td>
                <td>{operador.experienciaComoOperador}</td>
                <td
                    style={{
                        color: operador.error >= 1 ? "red" : "white"
                    }}
                >
                    {operador.error}</td>
                <td style={{
                    textAlign: "right"
                }}>{new Intl.NumberFormat('de-DE').format(operador.unidadesContadas)}</td>
                <td style={{
                    textAlign: "right"
                }}>{new Intl.NumberFormat('de-DE').format(operador.unidadesContadasReal)}</td>
                {operador.estado_asistencia == "-1"
                    ? <td colSpan={2}><div className='text-center' style={{ backgroundColor: 'red', color: 'white', borderRadius: '20%' }}>BAJA</div></td>
                    : null}
                {operador.estado_asistencia == "-1"
                    ? null
                    : <td><div className={onColorAsistencia(operador.estado_asistencia)}></div></td>}
                {operador.estado_asistencia == "-1"
                    ? null
                    : <td><div className={onColorAsistencia2(operador.estado_asistencia)}></div></td>}
                {operador.estado_asistencia == "-1"
                    ? null
                    : <td><div className={onColorAsistencia3(operador.estado_asistencia)}></div></td>}
            </tr>
        );
    });

    const rowsBajas = bajas.map((operador, index) => {

        const captador = captadores.find((captador) => captador.idUsuario == operador.captador);
        //totales.exp += operador.experienciaComoOperador; 
        //totales.error += operador.error,
        //totales.sug += operador.unidadesContadas;
        //totales.real += operador.unidadesContadasReal;
        return (
            <tr key={index}>
                <td>{index + 1}</td>
                {isPermisoMall ? <td>{usuariosConPermisoMap.has(operador.id) ? <div className={'glyphicon glyphicon-ok ' + css.userConPermisoMall}></div> : <div className={'glyphicon glyphicon-remove ' + css.userSinPermisoMall} color='red'></div>}</td> : null}
                <td
                    style={{
                        color: operador.bloqueado == 1 || operador.estado_asistencia == '-1' ? "red" : (operador.bloqueadoCliente ? "orange" : "white")
                    }}
                >
                    {operador.nombreCorto}</td>
                <td style={{ color: operador.estado_asistencia == '-1' ? "red" : "white" }}>{captador ? captador.nombre : '-'}</td>
                <td style={{ color: operador.estado_asistencia == '-1' ? "red" : "white" }}>{operador.comuna}</td>
                <td>{operador.experienciaComoOperador}</td>
                <td
                    style={{
                        color: operador.error >= 1 ? "red" : "white"
                    }}
                >
                    {operador.error}</td>
                <td style={{ textAlign: "right" }}>{new Intl.NumberFormat('de-DE').format(operador.unidadesContadas)}</td>
                <td style={{
                    textAlign: "right"
                }}>{new Intl.NumberFormat('de-DE').format(operador.unidadesContadasReal)}</td>
                {operador.estado_asistencia == "-1"
                    ? <td colSpan={3}>
                        <div className={css.mytooltipInside} style={{ backgroundColor: 'red', color: 'white', borderRadius: '20%', width: 'full', textAlign: 'center', display: 'inline-block', position: 'relative' }}>
                            BAJA
                            <span className={css.tooltipTableInside}>
                                {operador.fecha_baja ? operador.fecha_baja : "Sin registro"}
                            </span>
                        </div>
                    </td>
                    : <td></td>}
                {/* {operador.estado_asistencia == "-1"
                    ? null
                    : <td><div className={onColorAsistencia2(operador.estado_asistencia)}></div></td>} */}
            </tr>
        );
    });

    return (
        <table className={css.tablaInfoNomina}>
            <thead>
                <tr>
                    <td></td>
                    <td colSpan={3}>{localN + " " + localC + " - " + fecha + "  -  " + mensaje}</td>
                </tr>
                <tr>
                    <td>#</td>
                    {isPermisoMall ? <th>Mall</th> : null}
                    <td>Operador</td>
                    <td>Captador</td>
                    <td>Comuna</td>
                    <td>EXP</td>
                    <td>Error</td>
                    <td style={{ textAlign: "right" }}>Sug.</td>
                    <td style={{ textAlign: "right" }}>Real</td>
                    <td><span className='glyphicon glyphicon-check'></span></td>
                    <td><span className='glyphicon glyphicon-calendar'></span></td>
                    <td><span className='glyphicon glyphicon-map-marker'></span></td>
                </tr>
            </thead>
            <tbody>
                {rows}
                {escondidos.length > 0 ? <tr>
                    <td colSpan={4} style={{ height: '10px' }}></td>
                </tr> : null}
                {escondidos.length > 0 ? <tr>
                    <td></td>
                    <td colSpan={3}>Escondidos</td>
                </tr> : null}
                {rowsEscondidos}
                <tr>
                    <td></td>
                    {isPermisoMall ? <td></td> : null}
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td style={{ textAlign: "right" }}>{new Intl.NumberFormat().format(totales.sug)}</td>
                    <td style={{ textAlign: "right" }}>{new Intl.NumberFormat().format(totales.real)}</td>
                </tr>
                <tr>
                    <td></td>
                    {isPermisoMall ? <td></td> : null}
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td style={{ textAlign: "right" }}>{new Intl.NumberFormat().format(totales.sug - stock)}</td>
                    <td></td>
                </tr>
            </tbody>
            <tfoot>
                {bajas.length > 0 ? <tr>
                    <td colSpan={4} style={{ height: '10px' }}></td>
                </tr> : null}
                {rowsBajas}
            </tfoot>

        </table>
    );
}

const TableNominaAnterior = ({ fecha, turno, nomina, stats }) => {
    const rows = stats == "sin datos" ? null : (stats ? nomina.map((operador, index) => {
        return (
            <tr key={index}>
                <td>{operador.operador}</td>
                <td
                    style={{
                        color: operador.error >= 1 ? "red" : "white"
                    }}
                >
                    {operador.error}</td>
                <td style={{
                    textAlign: "right"
                }}>{new Intl.NumberFormat('de-DE').format(operador.conteo)}</td>
            </tr>
        );
    }) : nomina.map((operador, index) => {
        return (
            <tr key={index}>
                <td>{operador.operador}</td>
            </tr>
        )
    })
    )

    const columns = stats == "sin datos" ? null : (stats ?
        <tr>
            <td>Operador</td>
            <td>Error</td>
            <td>Conteo</td>
        </tr>
        :
        <tr>
            <td>Titulares</td>
        </tr>)

    const foot = stats == "sin datos" ? null : (stats ?
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        :
        <tr>
            <td></td>
        </tr>)
    return (
        <table className={css.tablaNominaAnterior}>
            <thead>
                <tr>
                    <td>{fecha == "Sin datos" ? fecha : fecha + " - " + turno}</td>
                </tr>
                {columns}
            </thead>
            <tbody>
                {rows}
            </tbody>
            <tfoot>
                {foot}
                {/*<tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td style={{textAlign: "right"}}>{new Intl.NumberFormat().format(totales.sug - stock)}</td>
                    <td></td>
                </tr>*/}
            </tfoot>

        </table>
    );
}

RowInventario.propTypes = {
    // Objetos
    puedeModificar: React.PropTypes.bool.isRequired,
    puedeModificarDotaciones: React.PropTypes.bool.isRequired,
    index: React.PropTypes.number.isRequired,
    inventario: React.PropTypes.object.isRequired,
    opcionesLideres: React.PropTypes.array.isRequired,
    opcionesSupervisores: React.PropTypes.array.isRequired,
    captadoresDisponibles: React.PropTypes.array.isRequired,
    mostrarSeparador: React.PropTypes.bool.isRequired,
    // Metodos
    lideresDisponibles: React.PropTypes.func.isRequired,
    guardarInventario: React.PropTypes.func.isRequired,
    guardarNomina: React.PropTypes.func.isRequired,
    focusRow: React.PropTypes.func.isRequired,
    agregarCaptador: React.PropTypes.func.isRequired,
    quitarCaptador: React.PropTypes.func.isRequired,
    agregarRegionesCaptador: React.PropTypes.func.isRequired,
    cambiarAsignados: React.PropTypes.func.isRequired,
    estadoSolicitud: React.PropTypes.func,
    saveDepartureTime: React.PropTypes.func.isRequired
}
RowInventario.defaultProps = {
    mostrarSeparador: false
}

export default RowInventario


// WEBPACK FOOTER //
// ./frontEnd/inventarios/programacion-semanal/RowInventarioSemanal.jsx